/**
 * TODO - preamble
 */
import './main.scss';

import './polyfills/polyfills';

import { SheerIdJsApi } from './lib/types/types';

import { VerificationFormEs5 } from './es5Bindings/VerificationForm';
import { BirthdateField } from './es5Bindings/BirthdateField';
import { StudentTypeaheadField } from './es5Bindings/StudentTypeaheadField';

// Import as much as possible from es6, to recycle that interface and ensure it stays functional
import {
    addHook,
    conversion,
    setViewModel,
    resetViewModel,
    setOptions,
    setMetadata,
    getMetadata,
} from './es6';

// Modify window interface to allow the SheerID object.
declare global {
    interface Window {
        sheerId: SheerIdJsApi;
        NREUM: any; // New Relic
    }
}

// If you just use the outputted bundle, and don't include the es6 source code in your project/build,
// this SheerID object is the API you'd interact with.
// See /examples/main.html
// Implements the SheerIdJsApi interface
// window.sheerid interface:
const windowInterface: SheerIdJsApi = {
    setViewModel,
    resetViewModel,
    setOptions,
    setMetadata,
    getMetadata,
    StudentTypeaheadField,
    BirthdateField,
    conversion,
    addHook,
    VerificationForm: VerificationFormEs5,
};

window.sheerId = windowInterface;


// TODO - remove. Use es6.tsx instead
export { setOptions } from './options/options';
export { VerificationForm } from './components/VerificationForm/VerificationFormComponent';
export { overrideComponent } from './lib/componentOverride/componentOverride';
// END TODO - remove. Use es6.tsx instead
